export default "/images/preview.svg?28455322c7d5584818ebc9c7df81859d";